import { useContext, useMemo, useState, useEffect } from 'react';
import { ThemeContext } from 'styled-components';
import { i as isFunction } from '../../LocalModules/storm-ui-utils/dist/esm/isFunction-DjxTmSal-DjxTmSal.js';
import { i as isString } from '../../LocalModules/storm-ui-utils/dist/esm/isString-D4CFRAVS-D4CFRAVS.js';

function useBrowserIsMobile() {
  var _useContext;
  /* outside the browser context always return undefined */
  if (!isFunction(window.matchMedia)) {
    return undefined;
  }
  const mediaQuery = (_useContext = useContext(ThemeContext)) === null || _useContext === void 0 || (_useContext = _useContext.mobile) === null || _useContext === void 0 ? void 0 : _useContext.mediaQuery;

  /* Return undefined if we do not have media query to detect mobile/not-mobile status */
  if (!isString(mediaQuery)) {
    return undefined;
  }

  /* Create a matchMedia object. Recreate it if the mediaQuery changes */
  const isMobileMatchMedia = useMemo(() => window.matchMedia(mediaQuery), [mediaQuery]);
  const [isBrowserMobile, setBrowserMobile] = useState(isMobileMatchMedia.matches);
  useEffect(() => {
    /* setup a listener for browser change its mobile/not-mobile status */
    const isMobileMatchMediaListener = event => {
      setBrowserMobile(event.matches);
    };
    isMobileMatchMedia.addListener(isMobileMatchMediaListener);
    return () => {
      var _isMobileMatchMedia$r;
      /* cleanup match media event listener */
      (_isMobileMatchMedia$r = isMobileMatchMedia.removeListener) === null || _isMobileMatchMedia$r === void 0 || _isMobileMatchMedia$r.call(isMobileMatchMedia, isMobileMatchMediaListener);
    };
  }, [mediaQuery]);
  return isBrowserMobile;
}

export { useBrowserIsMobile as u };
//# sourceMappingURL=useBrowserIsMobile-DWEPo99J.js.map
